/**
 * 初始化地图 - 高德地图版本
 */

/* global AMap */

var initMap = function (options) {
    options = Object.assign({
        tilt: 60,
        heading: 0
    }, options);
    var map = new AMap.Map(options.id, {
        resizeEnable: true,
        scrollWheel: true,
        keyboardEnable: true,
        dragEnable: true,
        zoomEnable: true,
        doubleClickZoom: true,
        mapStyle: 'amap://styles/whitesmoke',
        viewMode: '3D',
        pitch: options.tilt || 0,
        rotation: options.heading || 0,
    });

    // 添加比例尺控件
    var scaleCtrl = new AMap.Scale();
    map.addControl(scaleCtrl);

    if (options.center && options.zoom) {
        map.setCenter(options.center);
        map.setZoom(options.zoom);
    }

    return map;
};

// 高德地图内置浅色主题，无需自定义样式JSON
// 如需自定义样式，可通过高德地图官网创建样式后使用 amap://styles/xxx
var whiteStyle = 'amap://styles/whitesmoke';

export {
    initMap,
    whiteStyle
};
